import { ADD_APPOINTMENT, ADD_BULK_DATA, ALL_APPOINTMENT, ALL_BRANCH, ALL_COUNSELOR, ALL_DOCTOR, ALL_DOCTOR_SEARCH, ALL_PATIENT, ALL_PATIENT_SEARCH, ALL_PROBLEM, ALL_PROBLEM_SEARCH, CONFIRM_APPOINTMENT, COUNT_APPOINTMENT, CREATE_LEAD, DELETE_APPOINTMENT, DELETE_APPOINTMENT_OTP, DELETE_LEAD, EXPORT_APPOINTMENT, GET_ALL_LEAD, GET_APPOINTMENT, GET_APPOINTMENT_ID, GET_APPOINTMENT_SEARCH, GET_FOLLOWUP, GET_NEXT_FOLLOWUP, GET_PATIENT_EXCEL, SEARCH_ALL_APPOINTMENT, SEARCH_ALL_COUNSELOR, SEARCH_APPOINTMENT, SEARCH_LEAD, SLIP_APPOINTMENT, UPDATE_APPOINTMENT, UPDATE_LEAD, VERIFY_OTP, VIEW_LEAD } from "../actions/Files.action";

const initialState = {
    createLead: '',
    getAllLead: '',
    updateLead: '',
    deleteLead: '',
    verifyOtp: '',
    viewLead: '',
    addAppointment: '',
    getAppointment: '',
    getAppointmentById: '',
    confirmAppointment: '',
    updateAppointment: '',
    deleteAppointment: '',
    deleteOtpVerify: '',
    countAppointment: '',
    slipAppointment: '',
    allAppointment: '',
    allPatient: '',
    allBranch: '',
    allProblem: '',
    allDoctor: '',
    allCounselor: '',
    exportAppointment: '',
    getFollowup: '',
    getNextFollowup: '',
    addBulkData:'',
    getPatientExcel:''
}

const filesReducer = (state = initialState, action) => {
    switch (action.type) {
        case CREATE_LEAD:
            return { ...state, createLead: action.payload };
        case GET_ALL_LEAD:
            return { ...state, getAllLead: action.payload };
        case UPDATE_LEAD:
            return { ...state, updateAllFile: action.payload };
        case DELETE_LEAD:
            return { ...state, deleteLead: action.payload };
        case VERIFY_OTP:
            return { ...state, verifyOtp: action.payload };
        case SEARCH_LEAD:
            return { ...state, getAllLead: action.payload };
        case VIEW_LEAD:
            return { ...state, viewLead: action.payload };
        case ADD_APPOINTMENT:
            return { ...state, addAppointment: action.payload };
        case GET_APPOINTMENT:
            return { ...state, getAppointment: action.payload };        
        case GET_APPOINTMENT_ID:
            return { ...state, getAppointmentById: action.payload };
        case CONFIRM_APPOINTMENT:
            return { ...state, confirmAppointment: action.payload };
        case UPDATE_APPOINTMENT:
            return { ...state, updateAppointment: action.payload };
        case DELETE_APPOINTMENT:
            return { ...state, deleteAppointment: action.payload };
        case DELETE_APPOINTMENT_OTP:
            return { ...state, deleteOtpVerify: action.payload };
        case COUNT_APPOINTMENT:
            return { ...state, countAppointment: action.payload };
        case SLIP_APPOINTMENT:
            return { ...state, slipAppointment: action.payload };
        case ALL_APPOINTMENT:
            return { ...state, allAppointment: action.payload };
        case ALL_PATIENT:
            return { ...state, allPatient: action.payload };
        case ALL_PATIENT_SEARCH:
            return { ...state, allPatient: action.payload };
        case ALL_BRANCH:
            return { ...state, allBranch: action.payload };
        case ALL_PROBLEM:
            return { ...state, allProblem: action.payload };
        case ALL_PROBLEM_SEARCH:
            return { ...state, allProblem: action.payload };
        case ALL_DOCTOR:
            return { ...state, allDoctor: action.payload };
        case ALL_DOCTOR_SEARCH:
            return { ...state, allDoctor: action.payload };
        case ALL_COUNSELOR:
            return { ...state, allCounselor: action.payload };
        case SEARCH_ALL_COUNSELOR:
            return { ...state, allCounselor: action.payload };
        case EXPORT_APPOINTMENT:
            return { ...state, exportAppointment: action.payload };
        case SEARCH_APPOINTMENT:
            return { ...state, getAppointment: action.payload };
        case SEARCH_ALL_APPOINTMENT:
            return { ...state, allAppointment: action.payload };
        case GET_FOLLOWUP:
            return { ...state, getFollowup: action.payload };
        case GET_NEXT_FOLLOWUP:
            return { ...state, getNextFollowup: action.payload };
        case ADD_BULK_DATA:
            return { ...state, addBulkData: action.payload };
        case GET_PATIENT_EXCEL:
            return { ...state, getPatientExcel: action.payload };
        default:
            return state;
    }
}

export default filesReducer;
